"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _TitleFormatBadge = _interopRequireDefault(require("../../templates/TitleFormatBadge.html"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var TitleFormatBadge = Backbone.View.extend({
  initialize: function initialize(_ref) {
    var typeId = _ref.typeId;
    this.typeId = typeId;
    this.render();
  },
  render: function render() {
    this.setElement($((0, _TitleFormatBadge["default"])({
      typeId: this.typeId
    })));
  }
});
var _default = TitleFormatBadge;
exports["default"] = _default;